import { defineStore } from 'pinia'
import api from '@/utils/api'

export const useTaskStore = defineStore('tasks', {
  state: () => ({
    running: false,
    lastResults: {},
    error: null,
    taskHistory: []
  }),

  getters: {
    isTaskRunning: (state) => (taskName) => {
      return state.running && state.lastResults[taskName]?.status === 'running'
    }
  },

  actions: {
    async runTask(taskName) {
      this.running = true
      this.error = null
      
      try {
        // Add to history
        this.taskHistory.unshift({
          task: taskName,
          timestamp: new Date(),
          status: 'running'
        })
        
        const response = await api.post('/api/endpoints/tasks.php', {
          task: taskName
        })
        
        if (response.data.success) {
          this.lastResults[taskName] = {
            ...response.data.data,
            timestamp: new Date(),
            status: 'completed'
          }
          
          // Update history
          const historyItem = this.taskHistory[0]
          if (historyItem && historyItem.task === taskName) {
            historyItem.status = 'completed'
            historyItem.result = response.data.data
          }
          
          return response.data.data
        } else {
          throw new Error(response.data.error || 'Failed to run task')
        }
      } catch (error) {
        this.error = error.message
        
        // Update history
        const historyItem = this.taskHistory[0]
        if (historyItem && historyItem.task === taskName) {
          historyItem.status = 'error'
          historyItem.error = error.message
        }
        
        throw error
      } finally {
        this.running = false
      }
    },

    async runAllTasks() {
      return await this.runTask('all')
    },

    clearHistory() {
      this.taskHistory = []
    }
  }
})